var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react/react": () => (loadSingletonVersionCheckFallback("default", "react", [4,17,0,1], () => (__webpack_require__.e("vendors-node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom": () => (loadSingletonVersionCheckFallback("default", "react-dom", [4,17,0,1], () => (__webpack_require__.e("vendors-node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/@material-ui/core/@material-ui/core?48cf": () => (loadSingletonVersionCheckFallback("default", "@material-ui/core", [4,4,12,4], () => (Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_extends_js-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_styles_withStyles_js"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_utils_createChainedFunction_js-node_modules_materia-2044f0"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_Chip_Chip_js-node_modules_material-ui_core_esm_Fab_-2b40a5"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_getPrototypeOf_js-node_modules_babel_runtime_h-a71aa8"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_IconButton_IconButton_js-node_modules_material-ui_c-60667e"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_createClass_js-node_modules_material-ui_utils_-c26088"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_Avatar_Avatar_js-node_modules_material-ui_core_esm_-f56ed1"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_index_js"), __webpack_require__.e("webpack_sharing_consume_default_material-ui_styles_material-ui_styles")]).then(() => (() => (__webpack_require__(/*! @material-ui/core */ "./node_modules/@material-ui/core/esm/index.js"))))))),
	"webpack/sharing/consume/default/@material-ui/styles/@material-ui/styles": () => (loadSingletonVersionCheckFallback("default", "@material-ui/styles", [1,4,11,5], () => (Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_createClass_js-node_modules_material-ui_utils_-c26088"), __webpack_require__.e("vendors-node_modules_jss_dist_jss_esm_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_assertThisInitialized_js-node_modules_babel_ru-4f2c49")]).then(() => (() => (__webpack_require__(/*! @material-ui/styles */ "./node_modules/@material-ui/styles/esm/index.js"))))))),
	"webpack/sharing/consume/default/@material-ui/core/utils/@material-ui/core/utils?b800": () => (loadSingletonVersionCheckFallback("default", "@material-ui/core/utils", [1,4,0,0], () => (Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_extends_js-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_styles_withStyles_js"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_utils_createChainedFunction_js-node_modules_materia-2044f0"), __webpack_require__.e("webpack_sharing_consume_default_material-ui_styles_material-ui_styles"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_babel_runtime_helpers_e-4e9d441")]).then(() => (() => (__webpack_require__(/*! @material-ui/core/utils */ "./node_modules/@material-ui/core/esm/utils/index.js"))))))),
	"webpack/sharing/consume/default/@material-ui/core/styles/@material-ui/core/styles?4c88": () => (loadSingletonVersionCheckFallback("default", "@material-ui/core/styles", [1,4,12,1], () => (__webpack_require__.e("node_modules_material-ui_core_esm_styles_index_js-_67410").then(() => (() => (__webpack_require__(/*! @material-ui/core/styles */ "./node_modules/@material-ui/core/esm/styles/index.js"))))))),
	"webpack/sharing/consume/default/@material-ui/core/utils/@material-ui/core/utils?0ffe": () => (loadSingletonVersionCheckFallback("default", "@material-ui/core/utils", [1,4,12,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_material-ui_core_esm_utils_createChainedFunction_js-node_modules_materia-2044f0"), __webpack_require__.e("node_modules_material-ui_core_esm_utils_index_js")]).then(() => (() => (__webpack_require__(/*! @material-ui/core/utils */ "./node_modules/@material-ui/core/esm/utils/index.js"))))))),
	"webpack/sharing/consume/default/@material-ui/core/@material-ui/core?c579": () => (loadSingletonVersionCheckFallback("default", "@material-ui/core", [1,4,12,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_getPrototypeOf_js-node_modules_babel_runtime_h-a71aa8"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_createClass_js-node_modules_material-ui_utils_-c26088"), __webpack_require__.e("vendors-node_modules_material-ui_core_esm_index_js")]).then(() => (() => (__webpack_require__(/*! @material-ui/core */ "./node_modules/@material-ui/core/esm/index.js"))))))),
	"webpack/sharing/consume/default/@material-ui/core/styles/@material-ui/core/styles?0f26": () => (loadSingletonVersionCheckFallback("default", "@material-ui/core/styles", [1,4,0,0], () => (__webpack_require__.e("node_modules_material-ui_core_esm_styles_index_js-_67411").then(() => (() => (__webpack_require__(/*! @material-ui/core/styles */ "./node_modules/@material-ui/core/esm/styles/index.js")))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		"webpack/sharing/consume/default/react/react"
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/sharing/consume/default/react-dom/react-dom"
	],
	"src_bootstrap_ConfigWrapper_tsx": [
		"webpack/sharing/consume/default/@material-ui/core/@material-ui/core?48cf"
	],
	"webpack_sharing_consume_default_material-ui_styles_material-ui_styles": [
		"webpack/sharing/consume/default/@material-ui/styles/@material-ui/styles"
	],
	"webpack_sharing_consume_default_material-ui_core_utils_material-ui_core_utils": [
		"webpack/sharing/consume/default/@material-ui/core/utils/@material-ui/core/utils?b800"
	],
	"webpack_sharing_consume_default_material-ui_core_styles_material-ui_core_styles-webpack_shari-c8ee6c": [
		"webpack/sharing/consume/default/@material-ui/core/styles/@material-ui/core/styles?4c88",
		"webpack/sharing/consume/default/@material-ui/core/utils/@material-ui/core/utils?0ffe"
	],
	"webpack_sharing_consume_default_material-ui_core_material-ui_core": [
		"webpack/sharing/consume/default/@material-ui/core/@material-ui/core?c579"
	],
	"webpack_sharing_consume_default_material-ui_core_styles_material-ui_core_styles": [
		"webpack/sharing/consume/default/@material-ui/core/styles/@material-ui/core/styles?0f26"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory).catch(onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}